var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { Router, Switch } from 'react-router-dom';
import { observer, Provider } from 'mobx-react';
import cxs from 'cxs/component';
import { opacity } from 'helpers/Colors';
import Store from './Store';
import Theme, { mediaQueries } from './Theme';
import history from 'helpers/History';
import Main from 'scenes/Main';
import Login from 'scenes/Login';
import Recovery from 'scenes/Recovery';
import { Route, UIMessage } from 'components';
// Styles
// CoreUI Icons Set
import '@coreui/icons/css/coreui-icons.min.css';
// Import Flag Icons Set
/*import 'flag-icon-css/css/flag-icon.min.css';*/
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import './scss/style.css';
import { Scroll } from './elements';
import theme from './Theme';
import ListAll from './modules/Structures/container/ListAll';
import PropTypes from 'prop-types';
export const store = new Store();
let App = class App extends Component {
    componentWillMount() {
        // console.log(' App - componentWillMount')
        store.init().then(() => {
            // this.setState({storeRehydrated: true})
        });
    }
    render() {
        const { user } = store.users;
        const { inited } = store;
        return (React.createElement("div", null,
            React.createElement(Router, { history: history },
                React.createElement(Provider, { store: store },
                    React.createElement(WrapperContainer, null,
                        user && inited && (React.createElement(WrapperLeft, null,
                            React.createElement(WrapperContentLeft, null,
                                React.createElement(ListAll, null)))),
                        React.createElement(WrapperCenter, { user: user },
                            React.createElement(UIMessage, null),
                            React.createElement(WrapperMain, null,
                                React.createElement(Switch, null,
                                    React.createElement(Route, { exact: true, path: "/login", component: Login }),
                                    React.createElement(Route, { exact: true, path: "/recovery", component: Recovery }),
                                    React.createElement(Route, { path: "/", component: Main, auth: true }),
                                    React.createElement(Route, { render: () => React.createElement("p", null, "404") }))))))),
            React.createElement(WrapperBottom, null)));
    }
};
App = __decorate([
    observer
], App);
export default App;
const WrapperBottom = cxs('div')({
    [mediaQueries.desktop]: {
        maxWidth: '1366px',
        height: `${theme.common.size.bar / 2}px`,
        backgroundColor: theme.color.backlightgray,
    },
    [mediaQueries.xxl]: {
        margin: 'auto',
    },
});
const WrapperContainer = cxs('div')({
    display: 'flex',
    flexDirection: 'row',
    // height: 'fit-content',
    height: '100vh',
    position: 'relative',
    backgroundColor: 'white',
    maxWidth: '1366px',
    [mediaQueries.desktop]: {
        paddingTop: `${theme.common.size.bar / 2}px`,
        height: `calc(100vh - ${theme.common.size.bar / 2}px)`,
        backgroundColor: 'lightgray',
    },
    [mediaQueries.xxl]: {
        margin: 'auto',
    },
});
const WrapperContentLeft = cxs(Scroll)(({ user }) => ({
    backgroundColor: 'white',
    height: '100%',
    overflowY: 'auto',
}));
const WrapperMain = cxs(Scroll)(({ user }) => ({
    height: '100%',
    position: 'relative',
    overflow: 'hidden',
    [mediaQueries.md]: {
    // height: '100vh',
    },
    [mediaQueries.mobile]: {
        height: '100vh',
    },
}));
const WrapperLeft = cxs('div')({
    border: `1px solid ${theme.color.hairline}`,
    backgroundColor: 'white',
    display: 'none',
    /*overflowY: user?'scroll' : 'hidden',*/
    marginTop: '0px',
    marginLeft: `${theme.common.size.bar / 2}px`,
    marginRight: `${theme.common.size.bar / 4}px`,
    // marginBottom: '30px',
    flex: 1,
    maxWidth: '550',
    // maxWidth: '400px',
    [mediaQueries.desktop]: {
        display: 'block',
        width: '33%',
    },
    [mediaQueries.lg]: {
        display: 'block',
        width: '33%',
    },
});
const WrapperCenter = cxs('div')(({ user }) => (Object.assign(Object.assign({ backgroundColor: 'white', 
    /*display: 'flex',*/
    fontSize: Theme.fontSize.regular, fontFamily: Theme.fontFamily, fontWeight: Theme.fontWeight, lineHeight: Theme.lineHeight, color: Theme.color.secondary, textTransform: 'capitalize', '-webkit-tap-highlight-color': opacity(0.25, Theme.color.primary) }, (user
    ? {
        marginTop: 0,
        marginRight: `${theme.common.size.bar / 2}px`,
        marginLeft: `${theme.common.size.bar / 4}px`,
        minHeight: '100%',
        borderLeft: `1px solid ${theme.color.hairline}`,
        borderRight: `1px solid ${theme.color.hairline}`,
        borderTop: `1px solid ${theme.color.hairline}`,
    }
    : { margin: 'auto' })), { flex: 1, 
    // display: 'block',
    [mediaQueries.desktop]: Object.assign({ maxWidth: '500px' }, (user
        ? {
            width: '33%',
        }
        : undefined)), [mediaQueries.md]: Object.assign({}, (user
        ? {
            maxWidth: '100vw',
            margin: 0,
        }
        : undefined)) })));
WrapperCenter.propTypes = {
    user: PropTypes.object,
};



//////////////////
// WEBPACK FOOTER
// ./src/App.tsx
// module id = 65
// module chunks = 0